import { ComputedRef } from 'vue'

import { ProblemSearchModalStateType } from '@/domain/value_objects/problem/problemModalStateType'
import { ModalStateViewModel } from '@/presentation/viewmodels/modal/modalStateViewModel'
import { ProblemSearchModalStateViewModel } from '@/presentation/viewmodels/problem/problemSearchModalStateViewModel'

export class ModalStatePresenter {
  private viewModel: ModalStateViewModel
  private problemSearchModalStateViewModel: ProblemSearchModalStateViewModel

  constructor(
    viewModel: ModalStateViewModel,
    problemSearchModalStateViewModel: ProblemSearchModalStateViewModel = new ProblemSearchModalStateViewModel()
  ) {
    this.viewModel = viewModel
    this.problemSearchModalStateViewModel = problemSearchModalStateViewModel
  }

  get isShowLoginModal(): ComputedRef<boolean> {
    return this.viewModel.isShowLoginModal
  }

  setIsShowLoginModal(isShowLoginModal: boolean): void {
    this.viewModel.setIsShowLoginModal(isShowLoginModal)
  }

  reverseIsShowLoginModal(): void {
    this.viewModel.setIsShowLoginModal(!this.viewModel.isShowLoginModal.value)
  }

  get isShowProblemSearchModal(): ComputedRef<boolean> {
    return this.viewModel.isShowProblemSearchModal
  }

  openProblemSearchModal(modalState: ProblemSearchModalStateType): void {
    this.problemSearchModalStateViewModel.setModalState(modalState)
    this.viewModel.setIsShowProblemSearchModal(true)
  }

  setIsShowProblemSearchModal(isShowProblemSearchModal: boolean): void {
    this.viewModel.setIsShowProblemSearchModal(isShowProblemSearchModal)
  }

  reverseIsShowProblemSearchModal(): void {
    this.viewModel.setIsShowProblemSearchModal(!this.viewModel.isShowProblemSearchModal.value)
  }

  get isShowArenaModal(): ComputedRef<boolean> {
    return this.viewModel.isShowArenaModal
  }

  setIsShowArenaModal(isShowArenaModal: boolean): void {
    this.viewModel.setIsShowArenaModal(isShowArenaModal)
  }

  reverseIsShowArenaModal(): void {
    this.viewModel.setIsShowArenaModal(!this.viewModel.isShowArenaModal.value)
  }

  get isShowDashboardModal(): ComputedRef<boolean> {
    return this.viewModel.isShowDashboardModal
  }

  setIsShowDashboardModal(isShowDashboardModal: boolean): void {
    this.viewModel.setIsShowDashboardModal(isShowDashboardModal)
  }

  reverseIsShowDashboardModal(): void {
    this.viewModel.setIsShowDashboardModal(!this.viewModel.isShowDashboardModal.value)
  }

  get isShowUpdateModal(): ComputedRef<boolean> {
    return this.viewModel.isShowUpdateModal
  }

  setIsShowUpdateModal(isShowUpdateModal: boolean): void {
    this.viewModel.setIsShowUpdateModal(isShowUpdateModal)
  }

  reverseIsShowUpdateModal(): void {
    this.viewModel.setIsShowUpdateModal(!this.viewModel.isShowUpdateModal.value)
  }

  get isShowFreeSpaceModal(): ComputedRef<boolean> {
    return this.viewModel.isShowFreeSpaceModal
  }

  setIsShowFreeSpaceModal(isShowFreeSpaceModal: boolean): void {
    this.viewModel.setIsShowFreeSpaceModal(isShowFreeSpaceModal)
  }

  reverseIsShowFreeSpaceModal(): void {
    this.viewModel.setIsShowFreeSpaceModal(!this.viewModel.isShowFreeSpaceModal.value)
  }

  get isShowReviewAlertModal(): ComputedRef<boolean> {
    return this.viewModel.isShowReviewAlertModal
  }

  setIsShowReviewAlertModal(isShowReviewAlertModal: boolean): void {
    this.viewModel.setIsShowReviewAlertModal(isShowReviewAlertModal)
  }

  reverseIsShowReviewAlertModal(): void {
    this.viewModel.setIsShowReviewAlertModal(!this.viewModel.isShowReviewAlertModal.value)
  }

  get isShowSettingsModal(): ComputedRef<boolean> {
    return this.viewModel.isShowSettingsModal
  }

  setIsShowSettingsModal(isShowSettingsModal: boolean): void {
    this.viewModel.setIsShowSettingsModal(isShowSettingsModal)
  }

  reverseIsShowSettingsModal(): void {
    this.viewModel.setIsShowSettingsModal(!this.viewModel.isShowSettingsModal.value)
  }

  get isShowUserRegistrationModal(): ComputedRef<boolean> {
    return this.viewModel.isShowUserRegistrationModal
  }

  setIsShowUserRegistrationModal(isShowUserRegistrationModal: boolean): void {
    this.viewModel.setIsShowUserRegistrationModal(isShowUserRegistrationModal)
  }

  reverseIsShowUserRegistrationModal(): void {
    this.viewModel.setIsShowUserRegistrationModal(!this.viewModel.isShowUserRegistrationModal.value)
  }
}
